import './login.scss';
import { useAuthLogin } from './hooks/useAuthLogin';
import { LoginIntro } from './components/LoginIntro';
import { LoginForm } from './components/LoginForm';
import videoBg from '../../assets/Networking.mp4';

const Login = () => {
  const { inputs, err, isLoggingIn, handleChange, handleLogin, handleWeb3Login } = useAuthLogin();

  return (
    <div className='login'>
      <video autoPlay loop muted playsInline className="video-background">
        <source src={videoBg} type="video/mp4" />
      </video>

      <div className="video-overlay"></div>
      
      <div className="card">
        <LoginIntro />
        
        <LoginForm 
          inputs={inputs}
          err={err}
          isLoggingIn={isLoggingIn}
          handleChange={handleChange}
          handleLogin={handleLogin}
          handleWeb3Login={handleWeb3Login} // Test
        />
      </div>
    </div>
  );
};

export default Login;